module.exports = __webpack_public_path__ + "static/media/logo_bleu.ac28814a.svg";